var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Logo_svg__b)",
    d: "M3.568 5.375c0-1.765 0-2.647.344-3.321A3.15 3.15 0 0 1 5.289.677C5.963.333 6.845.333 8.609.333h6.016c1.765 0 2.647 0 3.321.344a3.15 3.15 0 0 1 1.377 1.377c.344.674.344 1.556.344 3.32v6.017c0 1.764 0 2.646-.344 3.32a3.15 3.15 0 0 1-1.377 1.377c-.674.344-1.556.344-3.32.344H8.61c-1.765 0-2.647 0-3.321-.344a3.15 3.15 0 0 1-1.377-1.377c-.344-.674-.344-1.556-.344-3.32z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Logo_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Logo_svg__d)",
    d: "M2.284 6.659c0-1.765 0-2.647.344-3.32A3.15 3.15 0 0 1 4.005 1.96c.674-.343 1.556-.343 3.32-.343h6.016c1.765 0 2.647 0 3.321.343a3.15 3.15 0 0 1 1.377 1.377c.343.674.343 1.556.343 3.321v6.016c0 1.764 0 2.647-.343 3.32a3.15 3.15 0 0 1-1.377 1.378c-.674.343-1.556.343-3.32.343H7.324c-1.764 0-2.646 0-3.32-.343a3.15 3.15 0 0 1-1.377-1.377c-.344-.674-.344-1.557-.344-3.321z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Logo_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Logo_svg__f)",
    d: "M1 7.943c0-1.764 0-2.647.343-3.32A3.15 3.15 0 0 1 2.72 3.244c.674-.343 1.557-.343 3.321-.343h6.016c1.765 0 2.647 0 3.321.343a3.15 3.15 0 0 1 1.377 1.377c.343.674.343 1.557.343 3.321v6.016c0 1.765 0 2.647-.343 3.32a3.15 3.15 0 0 1-1.377 1.378c-.674.343-1.556.343-3.321.343H6.041c-1.764 0-2.647 0-3.32-.343a3.15 3.15 0 0 1-1.378-1.377C1 16.606 1 15.723 1 13.959z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Logo_svg__b",
    x1: 11.617,
    x2: 11.617,
    y1: 0.333,
    y2: 16.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B81B03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Logo_svg__d",
    x1: 10.333,
    x2: 10.333,
    y1: 1.618,
    y2: 17.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC9F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Logo_svg__f",
    x1: 9.049,
    x2: 9.049,
    y1: 2.902,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E7BDB"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Logo_svg__a",
    width: 16.522,
    height: 16.522,
    x: 3.423,
    y: 0.042,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.066,
    dy: -0.079
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.106
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1549_6101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1549_6101",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Logo_svg__c",
    width: 16.443,
    height: 16.469,
    x: 2.192,
    y: 1.3,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.026,
    dy: -0.04
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.046
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1549_6101"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.079,
    dy: -0.146
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.086
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1549_6101",
    result: "effect2_dropShadow_1549_6101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_1549_6101",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Logo_svg__e",
    width: 16.549,
    height: 16.588,
    x: 0.907,
    y: 2.491,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.026,
    dy: -0.04
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.06
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1549_6101"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.132,
    dy: -0.185
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.113
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1549_6101",
    result: "effect2_dropShadow_1549_6101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_1549_6101",
    result: "shape"
  })))));
};
export default SvgLogo;